import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-toolbar-sidenav-mobile-toggle',
    templateUrl: './toolbar-sidenav-mobile-toggle.component.html',
    standalone: false
})
export class ToolbarSidenavMobileToggleComponent implements OnInit {

  @Output() openSidenav = new EventEmitter();

  ngOnInit() {
    // TODO document why this method 'ngOnInit' is empty
  
  }

}
